import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import ConfirmDialog from '@/shared/components/ConfirmDialog';
import NationalityTable from '../components/NationalityTable';
import { useDeleteNationality } from '../hooks/useNationalityMutations';
import DynamicFilterBuilder from '@/shared/filtering/DynamicFilterBuilder';
import { ADMIN_FILTER_RESOURCES } from '@/shared/filtering/types';
import { useDynamicAdminList } from '@/shared/filtering/useDynamicAdminList';

export default function NationalityListPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [deleteTarget, setDeleteTarget] = useState<any>(null);

  const list = useDynamicAdminList<any>(ADMIN_FILTER_RESOURCES.nationalities, { initialSortField: 'id', initialSortDir: 'asc' });
  const { data, isLoading } = list.searchQuery as any;
  const deleteMutation = useDeleteNationality();

  const handleConfirmDelete = () => {
    if (!deleteTarget) return;
    deleteMutation.mutate(deleteTarget.id, { onSettled: () => setDeleteTarget(null) });
  };

  return (
    <div>
      <PageHeader title={t('nationalities.title')} subtitle={t('nationalities.subtitle')} actionLabel={t('nationalities.add')} onAction={() => navigate('/nationalities/create')} />
      <DynamicFilterBuilder resource={list.resource} metadata={list.metadataQuery.data} value={list.filters} onChange={list.setFilters} onReset={list.resetFilters} />
      <div style={{ marginTop: 16 }}>
        <NationalityTable data={data?.content || []} loading={isLoading} sortField={list.sortField} sortDir={list.sortDir} onSort={list.handleSort} onEdit={(id) => navigate(`/nationalities/${id}/edit`)} onDelete={(item) => setDeleteTarget(item)} page={data?.currentPage ?? 0} pageSize={list.size} total={data?.totalItems ?? 0} onPageChange={list.setPage} />
      </div>
      <ConfirmDialog open={!!deleteTarget} title={t('nationalities.deleteTitle')} message={`${t('common.confirmDelete')} "${deleteTarget?.countryNameEn}"?`} onConfirm={handleConfirmDelete} onCancel={() => setDeleteTarget(null)} loading={deleteMutation.isPending} />
    </div>
  );
}
